import React, { Component } from "react"

class OpenOverlayButton extends Component {
  constructor(props) {
    super(props)
    this.type = props.type
  }

  render() {
    switch (this.type) {
      case "topmenu":
        return (
          <React.Fragment>
            <i id="searchFormTopMenu_Icon" onClick={(e) => this.props.onClick(e.currentTarget)} className="search-icon"></i>
          </React.Fragment>
        )
      case "mobile":
        return (
          <div id="search-link" className="hidden js-typeahead-module-topmenu">
            <i className="search-icon" onClick={(e) => this.props.onClick(e.currentTarget)}>
              <span></span>
            </i>
          </div>
        )
      default:
        return ""
    }
  }
}

export default OpenOverlayButton
